<template lang="pug">
  .simple-form
    .input-block
      //lei-popover(:text="searchBarScope")
      el-select.simple-select.lei-select.md(
        :value="fulltextFilter.label",
        @change="setFulltextFilter")
        el-option(v-for="(filter, i) in simpleSearchDropDown",
          :key="i", :label="filter.label", :value="filter")
      //lei-popover(:text="searchBarTerm")
      //lei-popover(:text="searchBarQuery")
      simple-input(:placeholder="searchLabel")
      .search-button(@click="makeSearch" data-test="search-button")
        lei-popover(:text="tooltips.searchBarQuery")
          img(src="/static/icons/search.svg")
    simple-filters
    .mobile-search-button
      .search-button(@click="makeSearch")
        img(src="/static/icons/search.svg")
</template>
<script>
import Autocomplete from '../lei-components/inputs/Autocomplete'
import { mapGetters, mapMutations, mapState, mapActions, } from 'vuex'
import {
  CHANGE_SIMPLE_SEARCH,
  SET_FULLTEXT_FILTER,
} from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import SimpleFilters from './SimpleFilters'
import LeiPopover from '../lei-components/LeiPopover'
import simple from '../../constants/tooltips/simple'
import SimpleInput from './SimpleInput'
import searchPlaceHolderMapper from '../../utils/searchPlaceholderMapper'

export default {
  components: {
    SimpleInput,
    LeiPopover,
    SimpleFilters,
    Autocomplete,
  },
  mixins: [ routerSearch, ],
  data () {
    return {
      tooltips: simple,
    }
  },
  computed: {
    searchLabel () {
      return searchPlaceHolderMapper(this.fulltextFilter.id)
    },
    ...mapState('search', [ 'fulltextFilter', 'simpleSearch', ]),
    ...mapGetters('search', [ 'simpleSearchDropDown', ]),
  },
  methods: {
    makeSearch () {
      this.routerSearch()
    },

    ...mapActions('search', [ 'autocomplete', ]),
    ...mapMutations('search', {
      setFulltextFilter: SET_FULLTEXT_FILTER,
      changeSimpleSearch: CHANGE_SIMPLE_SEARCH,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  $input-height = $input-md
  $input-height-mobile = $input-md

  .lei-select
    .el-input
      &:hover .el-input__suffix .el-input__suffix-inner .el-select__caret
        color $turquoise-color

  .simple-select
    height $input-height

    .el-input
      &__inner
        text-transform uppercase

  .simple-form
    margin 25px 0

    .simple-select
        width 17%

    .input-block
      display flex
      margin 25px 0
      border 1px solid #003336
      border-radius 1.5rem
      background #FFFFFF

    .search-button
      height $input-height
      position relative
      cursor pointer
      padding 10px 25px 10px 35px
      background $turquoise-color
      display flex
      align-items center
      justify-content center
      border-radius 1.5rem
      margin 1px
      color $cyprus-color
      text-transform uppercase;

      &:hover
        background-color #94EBDE

      img
        height 20px
        margin-right 10px

      span
        position absolute
        right -26px

    .mobile-search-button
      display none

  @media (max-width: $laptop)
    .simple-form
      margin 10px 0 0

      .simple-select
        width 25%

        .el-input
          font-size 12px

  @media (max-width: $tablet)
    .simple-form
      .simple-autocomplete
        .autocomplete-input-group
            border-left none
      .lei-select
        .el-input
          .el-input__inner
            border-bottom-left-radius none
            border-top-right-radius 1.5rem

      .simple-autocomplete
        .simple-input
          margin -1px -1px 5px 0

      .simple-select
        height $input-height-mobile
        width 100%

        .el-input
          font-size inherit

      .input-block
        height auto
        flex-direction column
        margin 0

        .search-button
          display none

      .mobile-search-button
        display flex
        width 100%

        .search-button
          height $input-height-mobile
          width 100%
          font-size 1rem
          letter-spacing 0.1rem
          font-weight bold
          color $turqoise-color
          text-transform uppercase

          img
            margin-right 0.5rem
            height 1.5rem
</style>



// WEBPACK FOOTER //
// src/components/search-components/SimpleForm.vue